class KvTextIn {
  constructor() {
    this.paragraph = document.querySelector('.js-kv-text');
    this.paragraphdesc = document.querySelectorAll('.js-kv-text-desc');
    this.textContent = this.paragraph.textContent;
  }
  init() {
    this.textFadeIn();
    // this.textDescFadeIn();
    // this.KvOtherFadeIn();
  }
  textFadeIn() {
    // this.newTextContent = [...this.textContent]
    //   .map((char) => `<span>${char}</span>`)
    //   .join('');
    // this.paragraph.innerHTML = this.newTextContent;
    // let tl = gsap.timeline();
    
    // window.addEventListener('load', function () {
    //   setTimeout(() => {
    //     tl.fromTo(
    //       '.js-kv-text span',
    //       {
    //         x: 8,
    //         autoAlpha: 0,
    //       },
    //       {
    //         duration: 5,
    //         delay: 0.5,
    //         x: 0,
    //         autoAlpha: 1,
    //         ease: 'expo.out',
    //         stagger: {
    //           each: 0.1,
    //           from: '0',
    //           grid: 'auto',
    //         },
    //       },
    //     );
    //     gsap.fromTo(
    //       '.js-fv-title-sp',
    //       {
    //         autoAlpha: 0,
    //       },
    //       {
    //         autoAlpha: 1,
    //         duration: 9,
    //         delay: 0.5,
    //         ease: 'expo.out',
    //       }
    //     )
    //   }, 1200);
    // });
  }
  KvOtherFadeIn() {
    
    window.addEventListener('load', function () {
      setTimeout(() => {
        gsap.fromTo(
          '.js-fade-in',
          {
            autoAlpha: 0,
          },
          {
            duration: 2,
            delay: 1,
            autoAlpha: 1,
            // ease: 'expo.out',
          },
        );
      }, 1200);
    });
  }
}
class BlurScrollIn {
  init() {
    this.Blur();
  }
  Blur() {
    gsap.utils.toArray('.js-trigger-section').forEach((target) => {
      if (target) {
        const targetLeft = target.querySelector('.js-section-heading');
        const targetRight = target.querySelector('.js-section-fadein');

        // 文字分割
        const paragraph = target.querySelector('.topic-heading-txt');
        const textContent = paragraph.textContent;
        const newTextContent = [...textContent]
          .map((char) => {
            if (char === ' ') {
              return `<br>`;
            } else {
              return `<span>${char}</span>`;
            }
          })
          .join('');
        paragraph.innerHTML = newTextContent;

        gsap.fromTo(
          targetLeft,
          {
            filter: 'blur(20px)',
            autoAlpha: 0,
          },
          {
            filter: 'blur(0px)',
            duration: 1.5,
            autoAlpha: 1,
            ease: 'expo.out',
            scrollTrigger: {
              trigger: target,
              start: 'top bottom-=400px',
            },
          },
        );

        gsap.fromTo(
          targetRight,
          {
            filter: 'blur(20px)',
            autoAlpha: 0,
          },
          {
            filter: 'blur(0px)',
            duration: 1.5,
            autoAlpha: 1,
            ease: 'expo.out',
            scrollTrigger: {
              trigger: target,
              start: 'top bottom-=400px',
            },
          },
        );

        let tl = gsap.timeline({
          scrollTrigger: {
            trigger: target,
            start: 'top bottom-=400px',
          },
        });
        const paragraphTarget = paragraph.querySelectorAll('span');
        tl.fromTo(
          paragraphTarget,
          {
            display: 'inline-block',
            color: 'rgba(0, 147, 210 ,1)',
          },
          {
            duration: 5,
            color: 'rgba(31, 39, 55, 1)',
            ease: 'expo.out',
            stagger: {
              each: 0.15,
              from: '0',
              grid: 'auto',
            },
          },
        );
      }
    });
  }
}
class photoSection {
  init() {
    this.blurIn();
  }
  blurIn() {
    const triggerCont = document.querySelector('.home-products');
    const targetCont = triggerCont.querySelector('.home-products-left');
    const targetLeft = triggerCont.querySelector('.home-products-image-left');
    const targetRight = triggerCont.querySelector('.home-products-image-right');
    gsap.fromTo(
      targetCont,
      {
        filter: 'blur(20px)',
        autoAlpha: 0,
      },
      {
        filter: 'blur(0px)',
        duration: 1.5,
        autoAlpha: 1,
        ease: 'expo.out',
        scrollTrigger: {
          trigger: triggerCont,
          start: 'top bottom-=400px',
        },
      },
    );
    gsap.fromTo(
      targetLeft,
      {
        willChange: 'transform',
        y: '25%',
      },
      {
        y: '-75%',
        scrollTrigger: {
          trigger: triggerCont,
          start: 'top bottom-=400px',
          end: 'bottom top',
          scrub: true,
        },
      },
    );
    gsap.fromTo(
      targetRight,
      {
        willChange: 'transform',
        y: '-116.666%',
      },
      {
        y: '-16.666%',
        scrollTrigger: {
          trigger: triggerCont,
          start: 'top bottom-=400px',
          end: 'bottom top',
          scrub: true,
        },
      },
    );
  }
}

class Sphere {
  init() {
    // this.Sphere();
    this.scrollIn();
  }
  scrollIn() {
    gsap.utils.toArray('.js-trigger-section').forEach((target) => {
      const circleGroup = target.querySelector('.p-circle');
      const targetCont = target.querySelectorAll('.p-circle path');
      if (circleGroup) {
        this.sample(target, targetCont);
      }
    });
  }
  sample(target, targetCont) {
    gsap.utils.toArray('.p-circle').forEach(() => {
      gsap.fromTo(
        targetCont,
        {
          scale: 0,
          fill: 'rgba(199, 205, 255, 1)',
        },
        {
          duration: 1,
          fill: 'rgba(239, 245, 255, 1)',
          scale: 1,
          stagger: {
            amount: 0.5,
            // grid: [19, 19],
            ease: 'power2.out',
            from: 'random',
          },
          scrollTrigger: {
            trigger: target,
            start: 'top bottom-=400px',
          },
        },
      );
    });
  }
}

class Top {
  constructor() {
    this.textIn = new KvTextIn();
    this.blurIn = new BlurScrollIn();
    this.photoSection = new photoSection();
    this.dots = new Sphere();
  }
  init() {
    this.textIn.init();
    this.blurIn.init();
    this.photoSection.init();
    this.dots.init();
  }
}

// トップページの場合、FVを過ぎたところでヘッダーの色を変更する
document.addEventListener('DOMContentLoaded', function() {
  // WordPressのトップページかどうかをチェック
  if (isFrontPage()) {
    const scrollHandler = new ScrollHandler();
  }
});
// WordPressのトップページかどうかを判定する関数
function isFrontPage() {
  return document.body.classList.contains('home') || document.body.classList.contains('front');
}
class ScrollHandler {
  constructor() {
    this.handleScroll = this.handleScroll.bind(this);
    this.headerColorElement = document.querySelector('.js-header-color');
    this.homeFvElement = document.querySelector('.home-fv');
    if (this.homeFvElement) {
      // home-fv要素が存在する場合のみ、スクロールイベントを実行する
      window.addEventListener('scroll', this.handleScroll);
    }
  }
  handleScroll() {
    if (this.homeFvElement.clientHeight < window.scrollY) {
      this.headerColorElement.classList.add('change-color');
    } else {
      this.headerColorElement.classList.remove('change-color');
    }
  }
  destroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}

export default Top;
